import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HEADERS } from 'src/app/constants/services-headers';

import { environment } from "src/environments/environment";

@Injectable({ providedIn: 'root' })
export class UserService {

  constructor(private http: HttpClient) { }

  // getAlertPermissions() Servicio para obtener permisos de notificaciones
  getAlertPermissions = (token: string): Observable<any> => this.http.get(environment.apiPath + "ApiHome/getAlerts" + token, HEADERS);

  // getModules() Servicio para obtener los módules accesibles del app
  getModules = (token: string): Observable<any> => this.http.get(environment.apiPath + "ApiHome/getModules" + token, HEADERS);

  // getMenu() Servicio para obtener el menu del app
  getMenu = (token: string): Observable<any> => this.http.get(environment.apiPath + "ApiHome/getPages" + token, HEADERS);

  // logOut() Método que llama al api para que elimine al usuario del login de la base de datos
  logOut = (token: string): Observable<any> => this.http.get(environment.apiPath + "ApiHome/logOut" + token, HEADERS);

  // logIn() Servicio para obtener la información del usuario conectado
  logIn = (token: string): Observable<any> => this.http.get(environment.apiPath + "ApiHome/getUser" + token, HEADERS);

}
